import { render, staticRenderFns } from "./updateLocationCategory.vue?vue&type=template&id=527c4784"
import script from "./updateLocationCategory.vue?vue&type=script&lang=js"
export * from "./updateLocationCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports